// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
Object.defineProperty(exports, 'Heading', {
  enumerable: true,
  get: function get() {
    return _Heading.Heading;
  }
});

var _Heading = require('./Heading');
